import Vue from 'vue';
import axios from 'axios';
import Router from '../router'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
};

const axiosInstance = axios.create(config);

axiosInstance.interceptors.request.use(
  (request) => request,
  (error) => Promise.reject(error)

);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  response => {
    let headers = response.headers;
    if (headers.securitystatus=='failure') {
      sessionStorage.removeItem('principal');
      localStorage.removeItem('mldn-session-id')
      Promise.reject(response).then(()=>{
        console.log("resolve")
      },error=>{
        // console.log(Router)
        // window.location.href='/login'
        Router.push({
          path: '/login'
        });
        Router.go(1);
      })
      return response
    } else {
      return response
    }
  },
  error => {
    const statusCode = error.response.status;
    console.info(`${statusCode}  ====   Msg ${error.response.statusText}`);
    if (statusCode == 404) {
      console.error('404 page');
    } else if (statusCode == 401) {
      // 路由跳转到登录界面
      sessionStorage.removeItem('principal');
      localStorage.removeItem('mldn-session-id')
      Router.push({
        path: '/login'
      });
      Router.go(1);
    } else if (statusCode == 500) {
      console.error('500 page');
    } else if (statusCode == 502) {
      sessionStorage.removeItem('principal');
      localStorage.removeItem('mldn-session-id')
      Router.push({
        path: '/login'
      });
      Router.go(1);
    }
    return error.response;
  }
);

Plugin.install = function axiosInstall(vueObj) {
  const _Vue = vueObj;
  _Vue.axios = axiosInstance;
  window.axios = axiosInstance;
  Object.defineProperties(_Vue.prototype, {
    axios: {
      get() {
        return axiosInstance;
      }
    },
    $axios: {
      get() {
        return axiosInstance;
      }
    },
  });
};

Vue.use(Plugin);

export default axiosInstance;
